import { handleErrors } from '@/shared/lib/errors';

import { API_URLS, apiWrapper } from '@/shared/api/main';

import { IErrorResponseData } from '@/shared/types/error';

/**
 * Добавить юзера в избранное, либо удалить из избранного
 * @param id - id юзера
 * @param action - принимает:'add' | 'remove', т.е. добавить или удалить юзера из избранного
 * @param folderIds - папки, в которые сразу положить юзера вместе с добавлением
 * в избранное (например, повтор добавления по «Вернуть» из снекбара снятия)
 */
export const bookmarkFavoriteUser = async (
  id: number,
  action: 'add' | 'remove',
  folderIds?: number[]
) => {
  const serverResponse =
    action === 'add'
      ? await apiWrapper.post<unknown, IErrorResponseData>(
          API_URLS.bookmarks.addUser(id),
          folderIds ? { folder_ids: folderIds } : undefined
        )
      : await apiWrapper.delete<unknown, IErrorResponseData>(
          API_URLS.bookmarks.removeUser(id)
        );

  if (!serverResponse.ok) {
    const { mainError } = handleErrors(serverResponse);
    throw new Error(mainError);
  }

  return serverResponse.data || ({} as unknown);
};
